import { useEffect, useRef, useState } from 'react'

import classNames from 'classnames'

import { PlaceNoticeLarge2Icon } from '@local/assets/icons'

import styles from './FallbackImage.module.scss'

const LARGE_IMAGE_SIZE = 120
const SMALL_IMAGE_SIZE = 50

enum ImageSize {
  SMALL,
  MEDIUM,
  LARGE,
}

interface Props {
  width: string | number
  height: string | number
  className?: string
  isDimmed?: boolean
}

const FallbackImage = ({ className, isDimmed, width, height }: Props) => {
  const errorRef = useRef<HTMLDivElement>(null)

  const [imageSize, setImageSize] = useState<ImageSize>(ImageSize.MEDIUM)

  useEffect(() => {
    if (!errorRef.current) return

    if (errorRef.current.parentElement) {
      const parentHeight = errorRef.current.parentElement.getBoundingClientRect().height

      if (parentHeight >= LARGE_IMAGE_SIZE) setImageSize(ImageSize.LARGE)

      if (parentHeight <= SMALL_IMAGE_SIZE) setImageSize(ImageSize.SMALL)
    }
  }, [errorRef])

  return (
    <div
      ref={errorRef}
      className={classNames(styles.icon_error_wrapper, className, {
        [styles.type_api_error]: isDimmed,
        [styles.type_small]: imageSize === ImageSize.SMALL,
        [styles.type_large]: imageSize === ImageSize.LARGE,
      })}
      style={{ width: `${width}px`, height: `${height}px` }}
    >
      <PlaceNoticeLarge2Icon className={styles.icon} aria-hidden="true" />
    </div>
  )
}

export default FallbackImage
